<template>
  <div class="footer-container flex-box">
    <div class="top-box">
      <div class="module-box inline-flex-box" v-for="(module, index) in moduleList" :key="index">
        <div class="module-title">{{ module.title }}</div>
        <div class="module-content">
          <div class="module-item pointer" v-for="(item, i) in module.list" :key="i" @click="toLink(item.link, item.isMyPage)">
            {{ item.label }}
          </div>
        </div>
      </div>
      <div class="contact-box inline-flex-box">
        <div class="contact-title">关注或联系我们</div>
        <div class="contact-description">添加璞华科技公众号，关注璞华咨询，添加微信咨询，更好了解服务。</div>
        <div class="contact-qr flex-box">
          <div class="qr-box">
            <el-image :src="require('@/assets/images/qr-1.png')" />
            <div class="qr-footer">公众号</div>
          </div>
          <div class="qr-box">
            <el-image :src="require('@/assets/images/qr-2.png')" />
            <div class="qr-footer">微信咨询</div>
          </div>
        </div>
        <div class="contact-phone">
          <span class="label">咨询热线：</span>
          <span class="number">4006-160-730</span>
        </div>
        <div class="contact-btn flex-box pointer" @click="toLink(linkMap.onlineConsultationUrl)">
          咨询在线客服
        </div>
      </div>
    </div>
    <div class="bottom-box flex-box">
      <div>
        <el-image :src="require('@/assets/images/badge.png')" />
        <span>
          苏ICP备14056277号-4 | 增值电信业务经营许可证：苏B2-20200733 | Copyright © 2023 璞华科技有限公司 All Rights Reserved
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { linkMap } from '@/utils'
export default {
  data() {
    return {
      linkMap,
      moduleList: [
        {
          title: '热门产品',
          list: [
            {
              label: '化工材料PLM',
              isMyPage: true,
              link: '/ChemicalIndustry'
            },
            {
              label: '食品饮料PLM',
              isMyPage: true,
              link: '/FoodBeverage'
            },
            {
              label: '日化美妆PLM',
              isMyPage: true,
              link: '/BeautyMakeup'
            },
          ]
        },
        {
          title: '行业',
          list: [
            {
              label: '化工材料行业',
              isMyPage: true,
              link: '/ChemicalIndustry'
            },
            {
              label: '食品饮料行业',
              isMyPage: true,
              link: '/FoodBeverage'
            },
            {
              label: '日化美妆行业',
              isMyPage: true,
              link: '/BeautyMakeup'
            },
            {
              label: '芯片半导体行业',
              isMyPage: true,
              link: '/Semiconductor'
            },
            {
              label: '医疗器械行业',
              isMyPage: true,
              link: '/MedicalEquipment'
            },
             {
              label: '电子高科技行业',
              isMyPage: true,
              link: '/ElectronTechnology'
            }
          ]
        },
        {
          title: '关于璞华',
          list: [
            {
              label: '企业介绍',
              isMyPage: true,
              link: '/AboutUs?anchorPoint=companyProfile'
            },
            {
              label: '企业文化',
              isMyPage: true,
              link: '/AboutUs?anchorPoint=enterpriseQualification'
            },
            {
              label: '联系我们',
              isMyPage: true,
              link: '/AboutUs?anchorPoint=contactus'
            }
          ]
        }
      ]
    }
  },
  methods: {
    toLink(link, isMyPage = false) {
      const { href } = this.$router.resolve({ path: link })
      if(isMyPage) return this.$router.push(href)
      window.open(link)
    }
  }
}
</script>

<style lang="scss" scoped>
.footer-container {
  height: 50.7rem;
  background: linear-gradient(360deg, #294E89 0%, #1A356E 100%);
  padding: 8rem 26rem 0;
  flex-direction: column;
  justify-content: space-between;

  .top-box {
    height: 33.5rem;

    .module-box {
      width: max-content;
      flex-direction: column;
      margin-right: 12.5rem;

      .module-title {
        font-size: 1.8rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 1.8rem;
        margin-bottom: 3rem;
      }

      .module-content {

        .module-item {
          font-size: 1.4rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 500;
          //color: #FFFFFF;
          color: #A0AEC6;
          line-height: 3.6rem;

          &:hover {
            color: #fff;
          }
        }
      }
    }

    .contact-box {
      margin-left: 3.5rem;
      flex-direction: column;

      .contact-title {
        font-size: 1.8rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 1.8rem;
        margin-bottom: 3.6rem;
      }
      .contact-description {
        font-size: 1.4rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #E7EAF0;
        line-height: 1.4rem;
        margin-bottom: 2rem;
      }
      .contact-qr {
        margin-bottom: 4rem;

        .qr-box {
          height: 14rem;
          background: #fff;
          margin-right: 3.2rem;
          display: flex;
          flex-direction: column;

          .el-image {
            width: 12rem;
            height: 12rem;
          }

          .qr-footer {
            width: 12rem;
            flex: 1;
            font-size: 1.2rem;
            font-family: PingFangSC, PingFang SC;
            font-weight: 400;
            color: #333333;
            background: #fff;
            line-height: 1.4rem;
            //display: flex;
            //justify-content: center;
            text-align: center;
          }
        }
      }
      .contact-phone {
        margin-bottom: 2rem;

        .label {
          font-size: 1.4rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 400;
          color: #9CABC5;
          line-height: 1.4rem;
        }
        .number {
          font-size: 1.8rem;
          font-family: PingFangSC, PingFang SC;
          font-weight: 600;
          color: #FFFFFF;
          line-height: 1.4rem;
        }
        span {
          margin-right: 0.4rem;
        }
      }
      .contact-btn {
        width: 12rem;
        height: 3.2rem;
        background: #FFFFFF;

        font-size: 1.4rem;
        font-family: PingFangSC, PingFang SC;
        font-weight: 400;
        color: #FB0000;
        line-height: 1.4rem;

        justify-content: center;
        align-items: center;

        &:active {
          background: #f8f8f8;
          box-shadow: 0 0.1rem 0.4em 0 rgb(255, 255, 255);
        }
      }
    }
  }

  .bottom-box {
    height: 6rem;
    font-size: 1.2rem;
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    color: #9CABC5;
    line-height: 1.2rem;
    border-top: 1px solid rgba(205, 220, 232, 0.6);
    align-items: center;
    justify-content: space-between;

    .el-image {
      width: 1.6rem;
      height: 1.6rem;
      margin-right: 0.4rem;
    }

    div {
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

}

@import "@/styles/mixins.scss";

@include mobile {
  .footer-container {
    height: auto;
    padding: 4rem 1.6rem 0;

    .top-box {
      height: auto;
      display: flex;
      flex-wrap: wrap;

      .module-box {
        width: 48%;
        margin: 0 0 2.8rem;
      }

      .contact-box {
        width: 100%;
        margin: 0 0 2.4rem;

        .contact-description {
          line-height: 2.2rem;
        }

        .qr-box {
          height: auto;
          margin-right: 2rem;

          .el-image {
            width: 9rem;
            height: 9rem;
          }

          .qr-footer {
            width: 9rem;
          }
        }
      }
    }

    .bottom-box {
      height: auto;
      padding: 1.6rem 0;
      font-size: 1.1rem;
      line-height: 1.8rem;

      div {
        flex-wrap: wrap;
        text-align: center;
      }
    }
  }
}
</style>
